/* Stock filtering uses one bundled section request, retaining normal links as fallback. */
(() => {
  if (window.hbCollectionNavigation) return;
  const provider = document.querySelector('collection-provider');
  const stock = document.querySelector('.hb-stock-toggle');
  const chips = stock?.closest('[id^="shopify-section-"]');
  if (!provider || !chips) return;
  window.hbCollectionNavigation = true;
  const main = provider.closest('[id^="shopify-section-"]');
  if (!main) return;
  const ids = [chips.id, main.id].map(id => id.replace('shopify-section-', ''));
  let controller, ownHistory = false, refreshTimer;
  const status = document.createElement('span');
  status.setAttribute('role', 'status');
  status.style.cssText = 'position:fixed;bottom:1rem;left:50%;transform:translateX(-50%);z-index:1000;background:#163340;color:white;padding:.65rem 1rem;border-radius:.5rem;font-size:1rem;pointer-events:none';
  status.hidden = true;
  document.body.append(status);
  function busy(value) {
    main.setAttribute('aria-busy', String(value));
    status.hidden = !value;
    status.textContent = value ? 'Updating products…' : '';
    chips.querySelectorAll('.hb-stock-toggle').forEach(link => {
      if (value) link.setAttribute('aria-busy', 'true');
      else link.removeAttribute('aria-busy');
    });
  }
  async function update(url, push, returnFocus) {
    controller?.abort();
    const request = new AbortController();
    controller = request;
    busy(true);
    const timeout = setTimeout(() => request.abort('timeout'), 12000);
    try {
      const endpoint = new URL(url);
      endpoint.searchParams.set('sections', ids.join(','));
      const response = await fetch(endpoint, { signal: request.signal });
      if (!response.ok) throw new Error('Collection unavailable');
      const sections = await response.json();
      const fresh = ids.map(id => {
        if (!sections[id]) throw new Error('Missing collection section');
        const doc = new DOMParser().parseFromString(sections[id], 'text/html');
        const root = doc.getElementById('shopify-section-' + id);
        if (!root) throw new Error('Missing collection content');
        return root;
      });
      if (controller !== request) return;
      chips.innerHTML = fresh[0].innerHTML;
      main.innerHTML = fresh[1].innerHTML;
      if (push) {
        ownHistory = true;
        history.pushState(history.state, '', url);
        ownHistory = false;
      }
      if (returnFocus) chips.querySelector('.hb-stock-toggle')?.focus({ preventScroll: true });
    } catch (error) {
      if (controller === request && (!request.signal.aborted || request.signal.reason === 'timeout')) {
        window.location.assign(url);
      }
    } finally {
      clearTimeout(timeout);
      if (controller === request) busy(false);
    }
  }
  document.addEventListener('click', event => {
    const link = event.target.closest?.('.hb-stock-toggle');
    if (!link || !chips.contains(link) || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const url = new URL(link.href);
    if (url.origin !== location.origin || url.pathname !== location.pathname) return;
    event.preventDefault();
    update(url.href, true, true);
  });
  window.addEventListener('popstate', () => update(location.href, false, false));
  // The theme's sorting/pagination already refreshes its grid. Keep the separate chips in sync.
  ['pushState', 'replaceState'].forEach(method => {
    const original = history[method];
    history[method] = function (...args) {
      const result = original.apply(this, args);
      if (!ownHistory) {
        controller?.abort();
        busy(false);
        clearTimeout(refreshTimer);
        const currentURL = location.href;
        refreshTimer = setTimeout(async () => {
          try {
            const url = new URL(currentURL);
            url.searchParams.set('section_id', ids[0]);
            const response = await fetch(url);
            if (!response.ok) return;
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            const fresh = doc.getElementById(chips.id);
            if (fresh && location.href === currentURL) chips.innerHTML = fresh.innerHTML;
          } catch (_) { /* Normal navigation remains available. */ }
        }, 100);
      }
      return result;
    };
  });
})();
